<template>
<Teleport to="body">
  <div class="fixed inset-0 z-50 flex justify-center bg-black/60">
    <div class="m-5 w-full md:w-8/12 lg:w-4/12" @click.self="closeDialog(false)" >

      <div class="p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center">
        
        <div class="flex flex-col w-full text-black">
        
          <BlockUI :visible="blocked">

            <div v-if="blocked" class="absolute inset-0 flex items-center justify-center z-50 bg-black/20">
              <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="5" fill="transparent" animationDuration=".5s" />
            </div>

            <div class="flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]">
              <div>
                <font-awesome-icon :icon="['fas', 'fa-lock']" class="w-6 h-6 text-white" />
              </div>
              <div class="font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis"> 
                {{ $t('titulo.invitar.usuario') }}
              </div>
            </div>

            <Form @submit="onSubmit" :validation-schema="schema">

              <div class="container p-4 text-left space-y-2">

                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
                  <div class="w-full px-2 md:w-1/1">
                    <label class="block mb-1">{{ $t('label.mail') }}</label>
                    <Field name="mail" v-slot="{ field, errors }" v-model="mail">
                      <InputText v-bind="field" type="mail" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                      <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
                    </Field>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
                  <div class="w-full px-2 text-gray-600 text-sm text-center">
                    {{  $t('label.detalle.invitacion') }}
                  </div>
                </div>

              </div>


              <div class="p-3 flex flex-col md:flex-row gap-2 justify-end w-full mt-2 bg-gray-100">
                <a @click="closeDialog(false)" class="cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                  <font-awesome-icon :icon="['fas', 'fa-xmark']" /> {{ $t('boton.cancelar') }}
                </a>
                <button type="submit" class="cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                  <font-awesome-icon :icon="['fas', 'fa-check-double']" /> {{ $t('boton.aceptar') }}
                </button>
              </div>

            </Form>

          </BlockUI>


        </div>
      </div>

    </div>
  </div>
</Teleport>  

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent, PropType } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';

import Swal from 'sweetalert2'
import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';
import ProgressSpinner from 'primevue/progressspinner';

import { ConfiguracionMeeting, Empresa } from 'qreventos-suite/src/services/suite.interfaces';
import seguridadServices from '@/services/seguridad.services';
import configuracionMeetingService from '@/services/configuracion.merting.services';
import suiteService, { Acreditado } from 'qreventos-suite/services';
import meetingService from 'qreventos-suite/meeting';

export default defineComponent({
  components: {
    InputText, BlockUI, ProgressSpinner,
    Field, ErrorMessage, Form
  },
  props: {
    empresa: {
      type: {} as PropType<Empresa>,
      required: true
    },
    closeFunction: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      blocked: false,
      acreditado: undefined as unknown as Acreditado,
      mail: '',
    };
  },
  computed: {
    schema() {
      return yup.object({
        mail: yup.string().required(this.$t('errors.ingrese.mail.invitacion')).email(this.$t('errors.correo.invalido')),
      });
    }
  },
  methods: {
    closeDialog(reload: boolean = false) {
      if (this.closeFunction) {
        this.closeFunction(reload);
      }
    },
    clearEnvioInvitacion() {
      this.mail = '';
    },
    async onSubmit() {
      try {
        this.blocked = true;

        const hash: string = seguridadServices.getLocalHash() as string;
        const configuracionMeeting:ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

        const ok: boolean = await meetingService.sendInvitacionMeeting(configuracionMeeting.evento.id, hash, this.empresa.id, this.mail);
        if (ok) {
          this.closeDialog(true);
        }
      }
      catch (error) {
        this.blocked = false;
        Swal.fire({ title: "Error", text: 'Error [' + error + ']', icon: "error" });
      } finally {
        this.blocked = false;
      }
    }, 
  },
  async mounted() {
    document.body.style.overflow = "hidden";
    this.clearEnvioInvitacion();
  },
  unmounted() {
    document.body.style.overflow = "";
  }
});
</script>